import Vue from 'vue';

export const state = () => ({
  uploading: {},
  uploaded: {},
  uploadSpeedTracking: {},
});

export const mutations = {
  startUpload(state, {
    id, file, missionOfferItemId, mediaId,
  }) {
    if (!state.uploading[missionOfferItemId]) {
      Vue.set(state.uploading, missionOfferItemId, []);
    }
    state.uploading[missionOfferItemId].push({
      id,
      mediaId,
      file,
      thumbnail: null,
      progress: 0,
      tracking: Date.now(),
    });
  },
  cancelUpload(state, { id, missionOfferItemId }) {
    const uploadings = state.uploading[missionOfferItemId];
    Vue.delete(state.uploadSpeedTracking, missionOfferItemId);
    const index = uploadings.findIndex((uploading) => uploading.id === id);
    uploadings.splice(index, 1);
  },
  setUploadThumbnail(state, { id, missionOfferItemId, thumbnail }) {
    const uploads = state.uploading[missionOfferItemId];
    uploads.find((uploading) => uploading.id === id).thumbnail = thumbnail;
  },
  setUploadProgress(state, {
    id, missionOfferItemId, progress, file: { size },
  }) {
    const uploads = state.uploading[missionOfferItemId];
    const upload = uploads.find((uploading) => uploading.id === id);

    const timeDelta = Date.now() - upload.tracking;
    const progressDelta = progress - upload.progress;
    if (timeDelta > 0 && progressDelta) {
      upload.progress = progress;
      upload.tracking = Date.now();
      const speed = (size * progressDelta * 0.01) / timeDelta;
      Vue.set(state.uploadSpeedTracking, missionOfferItemId, speed);
    }
  },
  setUploadMediaId(state, { id, missionOfferItemId, mediaId }) {
    const uploads = state.uploading[missionOfferItemId];
    uploads.find((uploading) => uploading.id === id).mediaId = mediaId;
  },
  finishUpload(state, { id, missionOfferItemId }) {
    const uploadings = state.uploading[missionOfferItemId];
    Vue.delete(state.uploadSpeedTracking, missionOfferItemId);
    const index = uploadings.findIndex((uploading) => uploading.id === id);
    const uploading = uploadings.splice(index, 1)[0];

    if (!state.uploaded[missionOfferItemId]) {
      Vue.set(state.uploaded, missionOfferItemId, []);
    }
    state.uploaded[missionOfferItemId].push({
      id,
      thumbnail: uploading.thumbnail,
    });
  },
};

export const getters = {
  isMediaIdReserved(state) {
    return (missionOfferItemId, mediaId) => (state.uploading[missionOfferItemId] || [])
      .some((upload) => upload.mediaId === mediaId);
  },
  totalProgression({ uploading }) {
    const uploads = Object
      .values(uploading)
      .reduce((arr, uploadings) => arr.concat(...uploadings), []);

    const totalUploadSize = uploads.reduce((total, { file: { size } }) => total + size, 0);
    if (!totalUploadSize) return 0;
    const totalUploadedSize = uploads
      .reduce((total, { file: { size }, progress }) => total + (size * progress * 0.01), 0);
    return (totalUploadedSize / totalUploadSize) * 100;
  },
  remainingTime({ uploading, uploadSpeedTracking }) {
    const speed = Object
      .values(uploadSpeedTracking)
      .reduce((total, speedTrack) => total + speedTrack, 0);

    if (speed === 0) return undefined;

    const uploads = [];
    Object.values(uploading).forEach((missionUploads) => {
      missionUploads.forEach((upload) => uploads.push(upload));
    });
    const remainingSize = uploads
      .reduce((total, { file: { size }, progress }) => total + (size * (100 - progress) * 0.01), 0);

    return `${Math.ceil(remainingSize / speed / 1000 / 60)} mins`;
  },
};
